import type { Permission } from '@cqinv/shared';
import type { SesionMe } from '../features/session/api';

export function puede(sesion: SesionMe, permiso: Permission): boolean {
  return sesion.permissions.includes(permiso);
}
